import { UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { BLOCK_TYPES } from '@app/infrastructure/utils/constants';
import { IDayBlockDTO } from '../day-block';
import { IFile } from '../image-block';
import { IGradeUnitDayDTO } from './grade-unit-day';
import { IFormattedTranscriptWord, ITranscriptWord } from './transcript';
import { FileUpload } from '../file';
import { GradeLevel } from '@models/grade-level';
import { EdReviewNoteDto } from '@models/ed-review';

export interface IKaraokeDTO extends IDayBlockDTO {
  file: FileUpload;
  originalTranscription?: string;
  editedTranscription?: string;
}

export interface IKaraokeStepper {
  stepper: MatStepper;
  form: UntypedFormGroup;
  loaders: boolean[];
  index: number;

  karaoke: IKaraokeDTO;
}

export class KaraokeStepper implements IKaraokeStepper {
  stepper: MatStepper = null;
  form: UntypedFormGroup = null;
  loaders: boolean[] = [];
  index: number = 0;
  karaoke: IKaraokeDTO = new KaraokeDTO();
}

export class KaraokeDTO implements IKaraokeDTO {
  id: number;
  position: number;
  gradeUnitId: number;
  gradeUnitDayId: number;
  gradeLevel: GradeLevel;
  dayId: number;
  pageId: number;
  blockType: BLOCK_TYPES = BLOCK_TYPES.KaraokeBlock;
  edReviews: EdReviewNoteDto[] = [];

  day: IGradeUnitDayDTO;
  file: FileUpload = null;
  originalTranscription: string = null;
  editedTranscription: string = null;

  constructor(configOverride?: Partial<IKaraokeDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IKaraokePlayer {
  audioUrl: string;
  transcriptWordList: ITranscriptWord[];
  editedTranscriptWordList: IFormattedTranscriptWord[];
}

export class KaraokePlayer implements IKaraokePlayer {
  audioUrl: string = '';
  transcriptWordList: ITranscriptWord[];
  editedTranscriptWordList: IFormattedTranscriptWord[];

  constructor(configOverride?: Partial<IKaraokePlayer>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IFormattedKaraokePlayer {
  audioUrl: string;
  transcriptWordList: IFormattedTranscriptWord[];
}

export class FormattedKaraokePlayer implements IFormattedKaraokePlayer {
  audioUrl: string = '';
  transcriptWordList: IFormattedTranscriptWord[];

  constructor(configOverride?: Partial<IFormattedKaraokePlayer>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
